// https://tigertech.feishu.cn/wiki/ZRB2wx4rBiXPvWkW9I5cNBKln3b
// https://apidocs.tigerfintech.com/repository/29/markdown/master/docs/%E6%96%87%E6%A1%A3%E6%A6%82%E8%BF%B0.md
export const HOST = ['https://ams-auth-us-test.tigerbrokers.net/authcenter', 'https://tesseract.tradeup.com'];

export const API = {
    // https://apidocs.tigerfintech.com/repository/29/api/master/APP-Web.json#/operations/post-api-v2-account-switch
    switchAccount: '/api/v2/account/switch' // 切换账户
};

export function bindCG() {
    const cfg = CG_API.tesseract?.TBUS;

    cfg && HOST.fill(cfg);
}
